import React from 'react';
import { Outlet, Link, useNavigate, useLocation } from 'react-router-dom';
import { Layout as AntLayout, Menu, Button, Avatar, Dropdown, Space } from 'antd';
import { UserOutlined, LogoutOutlined, DashboardOutlined, HomeOutlined, SettingOutlined } from '@ant-design/icons';
import { useAuth } from '../contexts/AuthContext';
import './Layout.css';

const { Header, Content, Footer } = AntLayout;

const Layout = () => {
  const { user, logout, isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  
  // Check if we're on a file access page
  const isFileAccessPage = location.pathname.startsWith('/file/');

  const userMenuItems = [
    {
      key: 'dashboard',
      icon: <DashboardOutlined />,
      label: 'Dashboard',
      onClick: () => navigate('/dashboard'),
    },
    ...(user?.role === 'admin' ? [{
      key: 'admin',
      icon: <SettingOutlined />,
      label: 'Admin Dashboard',
      onClick: () => navigate('/admin'),
    }] : []),
    {
      type: 'divider',
    },
    {
      key: 'logout',
      icon: <LogoutOutlined />,
      label: 'Logout',
      onClick: logout,
    },
  ];

  return (
    <AntLayout className="layout">
      <Header className="header">
        <div className="header-content">
          <Link to="/" className="logo">
            <img src="/logo.svg" alt="Mediatropy" height="40" />
          </Link>
          
          <div className="header-actions">
            {isAuthenticated ? (
              <Dropdown menu={{ items: userMenuItems }} placement="bottomRight">
                <Space className="user-info">
                  <Avatar src={user?.picture} icon={<UserOutlined />} />
                  <span className="user-name">{user?.name}</span>
                </Space>
              </Dropdown>
            ) : (
              !isFileAccessPage && (
                <Button type="primary" onClick={() => navigate('/login')}>
                  Login
                </Button>
              )
            )}
          </div>
        </div>
      </Header>

      <Content className="content">
        <Outlet />
      </Content>

      <Footer className="footer">
        <div className="footer-content">
          <p>&copy; 2025 Mediatropy. All rights reserved.</p>
        </div>
      </Footer>
    </AntLayout>
  );
};

export default Layout;